import { monthFilter } from "./month.filter";
import { formattedDataFilter } from "./formattedData.filter";

export default {
  monthFilter,
  formattedDataFilter
}